module.exports = __webpack_public_path__ + "img/buzou1.53e44eac.png";